export default __webpack_public_path__ + "static/media/Roboto-Black.988a1a31.ttf";